import {
  Component,


  ElementRef,
  EventEmitter, OnInit,



  Output, ViewChild
} from '@angular/core';
import { AppConfigService } from '../../../services/appconfig.service';
import { Legend, LegendTab } from './legend.model';
export * from './legend.model';
@Component({
  selector: 'lib-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss'],
})
export class LegendComponent implements OnInit {
  @ViewChild('element', { static: false }) elementRef: ElementRef;
  legends: Array<{ tab: LegendTab; legends: Legend[]; title: string }> = [
    { tab: LegendTab.QHChiTiet, legends: [], title: 'Quy hoạch chi tiết' },
    { tab: LegendTab.QHPhanKhu, legends: [], title: 'Quy hoạch phân khu' },
    // {
    //   tab: LegendTab.TaiNguyenMoiTruong,
    //   legends: [],
    //   title: 'Tài nguyên môi trường',
    // },
  ];
  @Output() tabChanged = new EventEmitter<LegendTab>();
  _tabSelected: LegendTab = LegendTab.QHChiTiet;
  get tabSelected() {
    return this._tabSelected;
  }
  set tabSelected(tab: LegendTab) {
    this._tabSelected = tab;
    this.tabChanged.emit(tab);
  }
  Tab = LegendTab;

  constructor(private configService: AppConfigService) {}

  async ngOnInit() {
    const legendConfig = (await this.configService.getApp().toPromise()).map
      .legend;
    this.legends.forEach((legend) => {
      legend.legends = legendConfig[legend.tab];
    });
  }

  handleChangeTabs(tab: LegendTab) {
    this.tabSelected = tab;
  }
}
